/**
 * THE ORG-NAME LAW, as the browser reads it.
 *
 * DERIVED FROM THE PUBLISHED CONTRACT, never transcribed. The
 * hand-written version had already drifted once -- `{1,30}` against the
 * server's 3-30, in the direction that lets a form accept a name the
 * API then refuses. orgname.schema.json is generated straight from
 * core/platform/org.py and depends on no route existing, which is why
 * it survived the evacuation that took `components.schemas.OrgName`.
 *
 * IT LIVES IN api/ BECAUSE TWO MODULES NEED IT. The front door reads a
 * host to decide where to send somebody and the onboarding form
 * validates what they typed -- and a module may not import another
 * module, front door or not (eslint boundaries/element-types). This
 * layer is what modules are allowed to share, and a law derived from a
 * published contract is exactly what it is for.
 *
 * The RESERVED names are not here and must not be added: they are
 * policy the server owns and the contract deliberately omits, so a
 * client copy would be a copy that silently falls behind.
 */
import orgNameContract from '../../../../orgname.schema.json';

export const ORG_NAME = {
  pattern: new RegExp(orgNameContract.pattern),
  minLength: orgNameContract.minLength,
  maxLength: orgNameContract.maxLength,
} as const;

/**
 * Would the server accept this as an org name?
 *
 * @param value - The candidate name.
 * @returns True when it satisfies the published shape. Says nothing
 *   about whether the name is TAKEN, or reserved -- both are the
 *   server's to answer.
 */
export function isOrgName(value: string): boolean {
  return (
    ORG_NAME.pattern.test(value) &&
    value.length >= ORG_NAME.minLength &&
    value.length <= ORG_NAME.maxLength
  );
}
